<template>
  <transition name="leftMove" appear>
    <div class="leftFlex">
      <!-- 选择页面 -->
      <div class="selectPages">
        <div class="describe">选择页面</div>
        <ul class="pages">
          <li class="page" v-for="item in pageList" :key="'page' + item.id">
            <div :class="selectPage == item.id ? 'wrap active' : 'wrap'" @click="switchPages(item.id)">
              <img :src="item.pageSrc" alt="页面模板" class="pageTemp" />
              <span class="name">{{ item.name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 业务组件 -->
      <div class="selectComponents">
        <div class="describe">
          <span>业务组件</span>
          <span class="desc">鼠标左键按住组件不放，拖动到右侧使用</span>
        </div>
        <div class="component">
          <ul class="list" ref="list" id="move">
            <li :class="!item.disabled ? 'wrap draw' : 'wrap'" v-for="(item, index) in list" :key="item.name + index + 'left'" :data-id="item.id">
              <div class="item">
                <img :src="item.icon" alt />
                {{ item.name }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import draggable from "vuedraggable";
import Sortable from "sortablejs";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      pageList: [
        {
          id: 1,
          name: "会员首页",
          pageSrc: require("@/assets/images/page1.png"),
        },
        {
          id: 2,
          name: "积分任务",
          pageSrc: require("@/assets/images/page2.png"),
        },
        {
          id: 3,
          name: "积分乐园",
          pageSrc: require("@/assets/images/page3.png"),
        },
        {
          id: 4,
          name: "积分商城",
          pageSrc: require("@/assets/images/page4.png"),
        },
        {
          id: 5,
          name: "个人中心",
          pageSrc: require("@/assets/images/page5.png"),
        },
      ],
      // 业务组件列表
      list: [],
      // 存储当前拖拽元素
      curItem: null,
      curHTML: null,
    };
  },
  watch: {
    selectPage(newVal) {
      this.list = [];
      while (this.$refs.list.childNodes.length > 0) {
        this.$refs.list.removeChild(this.$refs.list.childNodes[0]);
      }
      this.$nextTick(() => {
        this.list = this.componentList[+newVal - 1];
        console.log(this.list, 222222);
      });
    },
  },
  computed: {
    ...mapState(["selectPage", "componentList"]),
  },
  mounted() {
    document.getElementById("move").addEventListener("mouseover", this.throttle(this.onMouseover, 1000));
    // 初始化组件列表
    this.list = this.componentList[0];
    this.init();
  },
  methods: {
    ...mapMutations(["switchPages"]),
    init() {
      const self = this;
      let options = {
        animation: 500,
        draggable: ".draw", // 允许拖拽的项目类名
        // ghostClass: 'drawStyle',
        forceFallback: true,
        sort: false,
        group: { name: "list", pull: "clone", put: false },
        onStart(evt) {
          self.backGroundImage = self.list[+evt.oldIndex].bgImage;
          self.curItem = evt.item;
          self.curHTML = null;
          self.curHTML = evt.item.innerHTML;
        },
        onMove(evt) {
          const width = document.getElementById("centerFlex").clientWidth - 60;
          const html = `<img src="${self.backGroundImage}" style="width: ${width}px; height: auto" />`;
          self.curItem.innerHTML = html;
        },
        onUpdate(evt) {},
        onEnd: function(evt) {
          // 获取排序之后的data数据
          // that.value.splice(evt.newIndex, 0, that.value.splice(evt.oldIndex, 1)[0])
          // var newArray = that.value.slice(0)
          // that.value = []
          // that.$nextTick(function () {
          //     that.value = newArray
          //     console.log(that.value,"排序之后的data数据")
          // })
        },
      };
      var sortList = Sortable.create(this.$refs.list, options);
    },
    onMouseover() {
      if (!this.curItem) return;
      this.curItem.innerHTML = this.curHTML;
      console.log(this.curItem.innerHTML);
    },
    throttle(fn, wait) {
      var pre = Date.now();
      console.log(this.$store.state.pageConfig.integralShop, 33333333);
      return function() {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - pre >= wait) {
          fn.apply(context, args);
          pre = Date.now();
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped vars="{ backGroundImage, color }">
.leftFlex {
  width: 400px;
  height: 100%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: all 1s;
  // overflow: scroll;
  // &.centerMove-enter-active {
  //     transition: all 1s;
  // }
  // &::-webkit-scrollbar {
  //     width: 6px;
  //     height: 10px;
  // }
  // &::-webkit-scrollbar-track {
  //     background: rgba(246, 246, 246, 1);
  //     border-radius: 2px;
  // }
  // &::-webkit-scrollbar-thumb {
  //     background: #ddd;
  //     border-radius: 10px;
  // }
  // &::-webkit-scrollbar-thumb:hover {
  //     background: #ddd;
  // }
  .describe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 28px;
    text-align: left;
    height: 64px;
    background-color: #f5f5f5;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    .desc {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .selectPages {
    .pages {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      box-sizing: border-box;
      padding: 48px 62px 48px;
      .page {
        box-sizing: border-box;
        width: 50%;
        height: 128px;
        margin-bottom: 32px;
        &:nth-child(even) {
          padding-left: 16px;
        }
        &:nth-child(odd) {
          padding-right: 16px;
        }
        .wrap {
          position: relative;
          height: 128px;
          border: 1px solid #cccccc;
          cursor: pointer;
          transition: all 0.5s;
          &.active {
            border: 1px solid #7b61ff;
            .name {
              background-color: #7b61ff;
            }
          }
          .pageTemp {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            height: 126px;
            width: 45px;
          }
          .name {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(204, 204, 204, 0.8);
            transition: all 0.5s;
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }
  }
  .selectComponents {
    .component {
      box-sizing: border-box;
      padding: 28px;
      .list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .wrap {
          position: relative;
          box-sizing: border-box;
          width: 25%;
          padding: 0 6px;
          .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: -1;
            height: 76px;
            background-color: #f5f5f8;
            color: #333;
            font-size: 12px;
            font-weight: 400;
            cursor: pointer;
            img {
              width: 36px;
              margin-bottom: 10px;
            }
          }
          &:nth-child(4n + 1) {
            padding-left: 0;
          }
          &:nth-child(4n) {
            padding-right: 0;
          }
        }
      }
    }
  }
}
.leftMove-enter {
  transform: translateX(-100%);
}
.leftMove-enter-to {
  transform: translateX(0);
}
</style>
